import React from 'react';
import styles from '../../../styles/ReportsDashboard.module.css';

interface RateBarProps {
    rate: any
}

const RateBar: React.FC<RateBarProps> = ({ rate }) => {
    const color =
        rate >= 90 ? '#10b981' : rate >= 70 ? '#2563eb' : rate >= 50 ? '#d97706' : '#ef4444';
    return (
        <div className={styles.rateBarWrapper}>
            <div className={styles.rateBarTrack}>
                <div className={styles.rateBarFill} style={{ width: `${rate}%`, background: color }} />
            </div>
            <span className={styles.rateBarLabel} style={{ color }}>{rate}%</span>
        </div>
    );
}

export default RateBar;